import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DisplayComponent from '../BaseComponents/DisplayComponent';

import Header from '../Type/Header';
import Button from '../Link/Button';
import Grid from '../Grid/Grid';
import Cell from '../Grid/Cell';
import Section from '../Grid/Section';

// eslint-disable-next-line no-unused-vars
import GridStyle from '../Grid/Grid.module.css';
// eslint-disable-next-line no-unused-vars
import Tile from './Tile.module.css';
import { InteractiveDiv } from 'formlabs-web-components/Wrapper';

class TileGroup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mobile: false,
      open: true
    };
    this.groupToggle = this.groupToggle.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    this.setState({
      mobile: window.innerWidth <= 640,
      open: window.innerWidth >= 640
    });
  };

  groupToggle() {
    const { open } = this.state;
    this.setState({
      open: !open
    });
  }

  render() {
    const {
      title,
      copy,
      ctaText,
      ctaUrl,
      tileStyle,
      tileGroupId,
      children,
      buttonColor,
      navTitle
    } = this.props;
    const { mobile, open } = this.state;
    let largeSize = 4;
    const lastChild = true;
    if (children.length < 8 && children.length > 3) {
      largeSize = children.length;
    }
    if (children.length >= 8) {
      largeSize = 5;
    }

    const isOpen = !navTitle ? true : open;

    const totalTiles = children.length;
    let childrenArray = [];
    if (children) {
      childrenArray = React.Children.map(children, (child, index) => {
        if (totalTiles === index + 1) {
          return React.cloneElement(child, {
            tileStyle,
            lastChild
          });
        }
        return React.cloneElement(child, {
          tileStyle
        });
      });
    }

    return (
      <Section
        hasContainer
        sectionId={tileGroupId}
        marginBefore="6rem"
        marginBeforeSmall="6rem"
        marginBeforeMedium="6rem"
      >
        <Grid direction="x" primaryAlignment="align-center">
          <Cell largeSize={12}>
            <div style={{ textAlign: 'center' }}>
              {title && (
                <Header level={4} displayAs={4}>
                  {title}
                </Header>
              )}
              <p>{copy}</p>
            </div>
          </Cell>
        </Grid>
        {navTitle && mobile && (
          <InteractiveDiv
            styleName={`Tile.mobile-list-nav Tile.open-${isOpen}`}
            handler={this.groupToggle}
          >
            {navTitle}
          </InteractiveDiv>
        )}
        <div
          styleName={`GridStyle.grid-x GridStyle.grid-padding-x GridStyle.small-up-1 GridStyle.medium-up-3 GridStyle.large-up-${largeSize} Tile.mobile-list Tile.open-${isOpen}`}
          style={{ justifyContent: 'center' }}
        >
          {childrenArray.map(child => (
            <div
              key={child.key}
              styleName="GridStyle.cell"
              style={{ padding: 0 }}
            >
              {child}
            </div>
          ))}
        </div>
        <Grid direction="x" primaryAlignment="align-center">
          <div styleName="Tile.button-container">
            {ctaText && ctaUrl && (
              <Button color={buttonColor} url={ctaUrl}>
                {ctaText}
              </Button>
            )}
          </div>
        </Grid>
      </Section>
    );
  }
}

TileGroup.propTypes = {
  title: PropTypes.string,
  copy: PropTypes.string,
  tileGroupId: PropTypes.string,
  ctaText: PropTypes.string,
  ctaUrl: PropTypes.string,
  tileStyle: PropTypes.string,
  children: PropTypes.node,
  buttonColor: PropTypes.string,
  navTitle: PropTypes.string
};

export default DisplayComponent(TileGroup);
